import { useState } from "react";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";

const WarningModal = ({ show, setShowModal, getAllSP, loading }) => {
  const [openItems, setOpenItems] = useState(show);

  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
  };

  let submit = () => {
    getAllSP();
  };
  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Warning"}>
      <div style={{ padding: "10px" }}>
        <p>All Data will be replaced by new data. Do you want to continue?</p>
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={"OK"}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
        loadingState={loading}
      />
    </Reactportal>
  );
};

export default WarningModal;
